import { useState } from 'react'
import { useDocStore } from 'stores/DocStore'

export const useCommentArticleViewPaginatedFilters = ({
  anticipateResolvedToggle,
}: { anticipateResolvedToggle?: boolean } = {}) => {
  const [showAll, setShowAll] = useState(true)
  const docStore = useDocStore()
  const pageSize = 4

  const filters = [
    ...docStore.filters.active,
    ...docStore.filters.inactive.filter((f) => f.facet === 'user').filter((f) => docStore.filters.count(f) > 0),
  ]

  const resolvedFilter = docStore.filters.inactive.find((f) => f.facet === 'resolved' && docStore.filters.count(f) > 0)
  if (resolvedFilter) {
    if (anticipateResolvedToggle) {
      filters.unshift(resolvedFilter)
    } else {
      filters.push(resolvedFilter)
    }
  }

  const visibleFilters = filters.slice(0, pageSize)
  const moreFilters = filters.slice(pageSize)
  const allFilters = [...visibleFilters, ...moreFilters]
  const items = showAll ? allFilters : visibleFilters
  const total = allFilters.length

  return {
    total,
    items,
    toggle: setShowAll,
    canExpand: total > items.length,
    canCollapse: total > pageSize && showAll,
  }
}
